import { render } from "./AppFooter.vue?vue&type=template&id=0fdd1d2e"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__